var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 34",
    style: {
      enableBackground: "new 0 0 34 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.2,13.1c0,0.9-0.1,1.7-0.4,2.5c-1.3,5.8-12.4,12.9-12.9,13.2c-0.1,0.1-0.3,0.1-0.5,0.1 c-0.2,0-0.3-0.1-0.5-0.1c-2.2-1.4-4.4-3-6.4-4.8c-0.4-0.3-0.4-0.9-0.1-1.3c0.3-0.4,0.9-0.4,1.3-0.1c1.8,1.5,3.8,3,5.7,4.3 C21.7,24.8,29,19.3,30,15.2c0.2-0.7,0.3-1.4,0.3-2c0-2.3-1.3-4.5-3.3-5.6c-2.7-1.4-6-0.8-8,1.5c-0.4,0.4-0.9,0.4-1.3,0.1 c0,0,0,0-0.1-0.1c-2-2.3-5.3-2.9-8-1.5c-2,1.1-3.3,3.3-3.3,5.6c0,0.7,0.1,1.3,0.3,2c0.2,0.6,0.4,1.2,0.7,1.8h5.3l1.9-4.2 c0.2-0.5,0.7-0.7,1.2-0.5c0.2,0.1,0.4,0.3,0.5,0.6l1.3,5.6l1.7-2.8c0.2-0.3,0.5-0.4,0.8-0.4h3.3c0.5,0,0.9,0.4,0.9,0.9 c0,0.5-0.4,0.9-0.9,0.9h-2.8l-2.6,4.3c-0.2,0.3-0.4,0.4-0.8,0.4c-0.1,0-0.1,0-0.1,0c-0.4-0.1-0.7-0.3-0.7-0.7L15,15.9l-1,2.2 c-0.1,0.3-0.5,0.6-0.8,0.6H2.8c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9h2.7C5.2,16.5,5.1,16,5,15.6c-0.2-0.8-0.4-1.6-0.4-2.4 c0-3,1.6-5.7,4.3-7.2c3.1-1.7,6.9-1.2,9.6,1.2C21,4.8,24.8,4.3,27.9,6C30.5,7.4,32.2,10.1,32.2,13.1L32.2,13.1L32.2,13.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.d55668dd81bae668d640b61e107c7f4a.svg";
export { ForwardRef as ReactComponent };